import { Component, Input, OnChanges } from '@angular/core';
import { CalculaValorProgress } from 'src/app/utils/CalculaValorProgress';

@Component({
  selector: 'progressbar-primecap',
  templateUrl: './progressbar-primecap.component.html',
  styleUrls: ['./progressbar-primecap.component.css']
})
export class ProgressbarPrimecapComponent implements OnChanges {

  @Input() home?: boolean = true;
  @Input() valorRodadaInvestimento!: number;
  @Input() valorCaptadoRodadaInvestimento!: number;
  @Input() valorMinimoSucessoRodadaInvestimento!: number;

  valores: number[] = [];
  constructor() { }

  ngOnChanges(): void {
    this.valores = CalculaValorProgress.calcular(this.valorRodadaInvestimento,this.valorCaptadoRodadaInvestimento, this.valorMinimoSucessoRodadaInvestimento)
  }

}
